import { View, ViewType } from "@common/types/views/views";

export enum HistoryColumn {
    DATE = "date",
    UPDATED_BY = "updatedBy",
    ACTION = "action",
    ENTITY = "entity",
    ACTIONS = "actions",
}

export interface HistoryView extends View {
    type: ViewType.HISTORY;
    columns: Array<{ id: HistoryColumn; options?: any }>;
}
